import React, { useRef } from "react";
import { FaMapMarkerAlt } from "react-icons/fa"; 
import Slider from "react-slick";  // ✅ carousel import
import "./VideoSection.css";

const VideoSection = () => {
  const videoRef = useRef(null);

  const handlePlay = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  };

  // ✅ Slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,   // ek bar me 3 cards
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  const cards = [
    { img: "/assets/image1.jpg",  title: "Ultimate place",  },
    { img: "/assets/image2.jpg", title: "Discover India",  },
    { img: "/assets/image4.jpg", title: "Best Experience",  },
    { img: "/assets/image5.jpg",  title: "Beaches", },
    { img: "/assets/image6.jpg",  title: "Discover People" },
  ];

  return (
    <div>
      {/* ----------------- VIDEO SECTION ----------------- */}
      <div className="video-section">
        <div className="video-left">
          <video
            ref={videoRef}
            className="video-element"
            poster="/assets/image7.jpg"
            src="/assets/v5.mp4"
          ></video>
          <div className="video-overlay">
            <p className="new-label">new</p>
            <h2>Watch Our Video</h2>
            <p className="subtitle">The Beauty of Buddhism</p>
            <button className="play-btn" onClick={handlePlay}>▶</button>
          </div>
        </div>

        <div className="video-right">
          <h1>A Simply Perfect Place To Get Lost</h1>
          <p>
            Treat yourself with a journey to your inner self. Visit a mystique
            Tibet and start your spiritual adventure. We promise, you’ll enjoy
            every step you make.
          </p>
          <button className="see-more-btn">SEE MORE</button>

          <div className="location-box">
            <FaMapMarkerAlt className="location-icon" />
            <span className="location-text">India</span>
          </div>
        </div>
      </div>

      {/* ----------------- TRAVEL CARDS SLIDER ----------------- */}
      <div className="cards-slider">
        <Slider {...settings}>
          {cards.map((card, index) => (
            <div key={index} className="card">
              <img src={card.img} alt={card.title} />
              <div className="card-content">
                <p className="card-tag">{card.tag}</p>
                <h3>{card.title}</h3>
                <p className="card-price">{card.price}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default VideoSection;
